import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {I18nProvider} from '../_dashboard/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_dashboard/layout/core'
import {MasterInit} from '../_dashboard/layout/MasterInit'
import {AuthInit} from './modules/auth'
import {ConfirmProvider} from './components/ConfirmProvider'
import {MobileSelectSheet} from './components/MobileSelectSheet'

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <ConfirmProvider>
              <Outlet />
              <ToastContainer position='top-right' autoClose={5000} />
              <MobileSelectSheet />
              <MasterInit />
            </ConfirmProvider>
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
